// extracted by mini-css-extract-plugin
export default {"heading":"SubscribeModal_heading__+hG99","mainHeading":"SubscribeModal_mainHeading__oWg5C","subscriptionPlanName":"SubscribeModal_subscriptionPlanName__AgSoN"};